import { render, staticRenderFns } from "./MemberQna.vue?vue&type=template&id=dc136da8&scoped=true"
import script from "./MemberQna.vue?vue&type=script&lang=js"
export * from "./MemberQna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc136da8",
  null
  
)

export default component.exports